module.exports = __webpack_public_path__ + "img/live11.d3d7b373.png";